import $api from '../services';

export default {
    registerDevice(params) {
        return $api.post('profile/devices', params);
    },
    unregisterDevice(params) {
        return $api.delete('profile/devices', {}, { data: params });
    }
};
